/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

export const researchTitle=[
    "All", "RA", "RS", "DI", "RL", "ASQ", "SWT",
    "WE", "RO", "RWFIB", "RFIB", "SST",
    "FIB", "HIW", "WFD" 
]

export const researchClasses =[
    {
        id:"C1",
        type:"RA",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C2",
        type:"RS",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C3",
        type:"DI",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C4",
        type:"RL",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C5",
        type:"ASQ",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C6",
        type:"SWT",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C7",
        type:"WE",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C8",
        type:"RO",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C9",
        type:"RWFIB",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C10",
        type:"RFIB",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C11",
        type:"SST",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C12",
        type:"FIB",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C13",
        type:"HIW",
        title:"Class's Title",
        des: "Class's description"
    },
    {
        id:"C14",
        type:"WFD",
        title:"Class's Title",
        des: "Class's description"
    }

]